module.exports = __webpack_public_path__ + "img/zoomin.4e589da6.svg";